import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { availableThemes } from './themes';

const ThemeContext = createContext({ themeId: 'light', setThemeId: () => {} });

export const AppThemeProvider = ({ children }) => {
  const [themeId, setThemeId] = useState(() => {
    try {
      return localStorage.getItem('app.theme') || 'light';
    } catch (_) {
      return 'light';
    }
  });

  const themeConfig = availableThemes[themeId] || availableThemes.light;

  useEffect(() => {
    try {
      localStorage.setItem('app.theme', themeId);
    } catch (_) {}
  }, [themeId]);

  useEffect(() => {
    const root = document.documentElement;
    root.setAttribute('data-theme', themeId);
    const vars = themeConfig.cssVars || {};
    Object.keys(vars).forEach((key) => {
      root.style.setProperty(key, vars[key]);
    });
  }, [themeId, themeConfig]);

  const value = useMemo(() => ({ themeId, setThemeId }), [themeId]);

  return (
    <ThemeContext.Provider value={value}>
      <ThemeProvider theme={themeConfig.muiTheme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};

export const useAppTheme = () => useContext(ThemeContext);


